<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :modal="false"
        width="30%" height="65%">
        <template>
            <div class="flex jca mb30">
<!--                <div class="flex  column aic jcb width50">-->
<!--                    <div class="flex column jcb aic">-->
<!--                        <span class=" bold fs18">房间二维码</span>-->
<!--                        <img src="../../assets/vcode.png" alt="" class="flex width70 mt20">-->
<!--                    </div>-->
<!--                    <el-button type="primary" size="mini">分享二维码</el-button>-->
<!--                </div>-->
                <div class="flex  column aic jcb width100">
                    <div class="flex column aic jcb">
                        <span class="mt20 bold fs18">房间链接</span>
                        <span class="mt20" ref="copyContain">{{roomurl}}{{roomId}}</span>
                    </div>
                    <el-button type="primary" size="mini"
                               v-clipboard:copy="roomurl + roomId"
                               v-clipboard:success="onCopy"
                               v-clipboard:error="onError">复制链接</el-button>
                </div>


            </div>
        </template>
    </el-dialog>
</template>

<script>

  export default {
    name: "share-room-dialog",
    props: {
      mobile: String
    },
    data() {
      return {
        dialogVisible: false,
        form: {
          systemScore: ''
        },
          roomurl:'',
          roomId:''
      }
    },
    methods: {
      show(id) {
          console.log('url',url('hostname'))
          if(url('hostname') != 'localhost'){
              this.roomurl = `https://${url('hostname')}:${url('port')}/#/other/ychz/fullscreen?id=`;
          }else{
              this.roomurl = `https://localhost:8080/#/other/ychz/fullscreen?id=`;
              // this.roomurl = `https://${url('hostname')}:${url('port')}/#/other/ychz/fullscreen?id=`;
          }
          this.roomId = id;
          this.dialogVisible = true;
      },
      hide() {
        this.dialogVisible = false;
      },
      handleClose(){
        this.$emit('close')
      },
        // 复制成功
        onCopy(e){
            this.$message({
                message: '复制成功',
                type: 'success'
            });
        },
        // 复制失败
        onError(e){
            this.$message.error('复制失败');
        },
    },
  }
</script>

<style scoped>

</style>
